import { render, staticRenderFns } from "./credit-card-component.vue?vue&type=template&id=13459a63&scoped=true"
import script from "./credit-card-component.vue?vue&type=script&lang=js"
export * from "./credit-card-component.vue?vue&type=script&lang=js"
import style0 from "./credit-card-component.vue?vue&type=style&index=0&id=13459a63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13459a63",
  null
  
)

export default component.exports